import { IPage } from '@aon/aon-tws-common-ui';
import { ILibraryQuestion, IResponseOptionGroup } from '@aon/tws-common-ui-questions/build/lib/models';
import axios from 'axios';
import Constants from '../constants';
import { IQuestionLanguages, IQuestionTags, IQuestionTemplates } from '../models';

// All searching and sorting is happening on the client side
export function questionsQuery(isDemographic: boolean, cultureCode?: string) {
	let url =
		Constants.API_V2_QUESTIONS_URL +
		'?limit=10000&statuses=2&include=Dimensions&include=ResponseOptionGroup&include=ResponseOptions&include=Variations';
	if (isDemographic != null) {
		url += `&isDemographic=${isDemographic.toString()}`;
	}
	if (cultureCode) {
		url += `&cultureCode=${cultureCode}`;
	}
	return url;
}

export async function GetQuestions(isDemographic: boolean, cultureCode = 'en-US'): Promise<IPage<ILibraryQuestion>> {
	const res = await axios.get(questionsQuery(isDemographic, cultureCode));
	if (res.status === 200) {
		return {
			pageRange: JSON.parse(res.headers.range),
			items: res.data,
		};
	}
	return res.data;
}

export async function GetQuestionLanguages(): Promise<IQuestionLanguages[]> {
	const url = Constants.API_V2_QUESTION_VARIATIONS_URL + '?include=Languages';
	const response = await axios.get(url);
	return response.data.map((d: any) => {
		return {
			questionId: d.questionId,
			questionVariationId: d.questionVariationId,
			languageCodes: d.languages,
		};
	});
}

export async function GetQuestionTags(): Promise<IQuestionTags[]> {
	const response = await axios.get(Constants.API_V2_QUESTION_ALLTAGS_URL);
	return response.data;
}

export async function GetQuestionTemplates(): Promise<IQuestionTemplates[]> {
	const response = await axios.get(Constants.API_V2_QUESTION_ALLTEMPLATES_URL);
	return response.data;
}

export async function GetResponseOptionGroups(cultureCode?: string, excludeDemographic = true): Promise<IResponseOptionGroup[]> {
	let responseOptionGroupUrl = Constants.API_V2_RESPONSE_OPTION_GROUPS_URL + '?include=ResponseOptions';
	if (cultureCode) {
		responseOptionGroupUrl += `&cultureCode=${cultureCode}`;
	}
	const response = await axios.get(responseOptionGroupUrl);
	if (excludeDemographic) {
		return response.data.filter((d: IResponseOptionGroup) => d.responseOptionGroupTypeId !== 5);
	}
	return response.data;
}
